import axios from 'axios';
import store from '../store';

const config = process.env;

export default axios.create({
  baseURL: config.DOMAIN,
  timeout: 2000,
  headers: {
    Accept: 'application/json',
    token: store.state.token,
  },
});



// WEBPACK FOOTER //
// ./src/service/engine.js